import React from "react";
import { useTranslation } from "react-i18next";
import UploadTechnologyData from "./UploadTechnologyData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataTechnologyScreen = () => {
  debugLogPages(':: ImportDataTechnologyScreen');

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataTechnology" />
      <div className="d-flex justify-content-center page-title">{t("admin.importdata.technology.title")}</div>
      <hr className="line-hr" />

      <div>
        <UploadTechnologyData />
      </div>
    </>
  );
};

export default ImportDataTechnologyScreen;
